// Import Core
import React from 'react'
// Import Assets
import starSvg from '../../assets/icons/starRating.svg'

// Get number of stars
const Stars = ({starRating}) => {
  return [...Array(Number(starRating))].map((e, i) => <img key={`star-${i}`} src={starSvg} alt={`${starRating} stars`} className='star' />)
}

export default Stars


